import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const LinkedinIcon: React.FC<SvgProps> = ({ color, ...props }) => {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g id="entypo-social:linkedin-with-circle" clipPath="url(#clip0_223_83012)">
        <path
          id="Vector"
          d="M12 0.833008C5.63758 0.833008 0.47998 5.99061 0.47998 12.353C0.47998 18.7154 5.63758 23.873 12 23.873C18.3624 23.873 23.52 18.7154 23.52 12.353C23.52 5.99061 18.3624 0.833008 12 0.833008ZM9.17998 17.1278H6.84718V9.62061H9.17998V17.1278ZM7.99918 8.69901C7.26238 8.69901 6.78598 8.17701 6.78598 7.53141C6.78598 6.87261 7.27678 6.36621 8.02918 6.36621C8.78158 6.36621 9.24238 6.87261 9.25678 7.53141C9.25678 8.17701 8.78158 8.69901 7.99918 8.69901ZM17.7 17.1278H15.3672V12.9674C15.3672 11.999 15.0288 11.3414 14.1852 11.3414C13.5408 11.3414 13.158 11.7866 12.9888 12.215C12.9264 12.3674 12.9108 12.5834 12.9108 12.7982V17.1266H10.5768V12.0146C10.5768 11.0774 10.5468 10.2938 10.5156 9.61941H12.5424L12.6492 10.6622H12.696C13.0032 10.1726 13.7556 9.45021 15.0144 9.45021C16.5492 9.45021 17.7 10.4786 17.7 12.689V17.1278Z"
          fill={color || '#999999'}
        />
      </g>
      <defs>
        <clipPath id="clip0_223_83012">
          <rect width="24" height="24" fill="white" transform="translate(0 0.353027)" />
        </clipPath>
      </defs>
    </Svg>
  )
}

export default LinkedinIcon
